<template>
  <v-data-table
    :headers="[
      { text: 'Created date', value: 'createdAt' },
      { text: 'Average Score', value: 'scoreAverage' },
      { text: 'User', value: 'user.fullName' },
      { text: 'Verified', value: 'verified' },
      { text: 'Loan Product', value: 'product.internalName' },
    ]"
    :items="displayedReviews"
    sort-by="createdAt" sort-desc
    show-expand
  >
    <template #top>
      <div class="table-header-wrapper">
        <div>
          <h2>Reviews</h2>

          <div class="grid-wrapper scores">
            <template v-for="field in reviewFields">
              <label :key="'label-' + field">{{ field | friendlyDisplayKeys }}</label>
              <star-rating
                :rating="organization[field]"
                :size="20"
                :editable="false" />
            </template>
          </div>
        </div>
        <div class="filter-wrapper">
          <v-menu :close-on-content-click="true" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn class="default-btn link" v-on="on">
                <span class="help big">Filter:</span>
                {{ activeFilterText }} <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="option in filterOptions"
                :key="option.key"
                @click="activeFilter = option.key">
                {{ option.text }}
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </div>
    </template>

    <template #item.createdAt="{ value }">
      {{ value | date }}
    </template>

    <template #item.scoreAverage="{ value }">
      <star-rating
        :rating="value"
        :editable="false"
        :size="20"
        justify="flex-start" />
    </template>

    <template v-slot:item.verified="{ value }">
      <v-icon v-if="value">mdi-check</v-icon>
    </template>

    <template #item.product.internalName="{ item }">
      {{ item.product.internalName || item.product.title }}
    </template>

    <template #expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <ReviewDetails
          :review="item"
          :key="`${item.id}-${item.responseFrom}-${item.responseMessage}`"
          @edit="$emit('edit', { id: item.id, ...$event })"/>
      </td>
    </template>

  </v-data-table>
</template>

<script>

import ReviewDetails from './ReviewDetails'

export default {
  name: 'ReviewsTable',
  components: {
    ReviewDetails,
  },

  props: {
    organization: {
      type: Object,
      default: () => ({}),
    },
    reviews: {
      type: Array,
      default: () => [],
    },
    filterOptions: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    reviewFields: [
      'scoreAverage',
      'scoreOverall',
      'scoreClarity',
      'scoreGathering',
      'scoreTimeliness',
      'scoreResponsiveness',
    ],
    activeFilter: 'all',
  }),

  computed: {
    activeFilterText () {
      const active = this.filterOptions.find(({ key }) => key === this.activeFilter)
      return (active || {}).text
    },

    displayedReviews () {
      return this.activeFilter === 'all'
        ? this.reviews
        : this.reviews.filter(({ product }) => product.title === this.activeFilter)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-header-wrapper {
  display: grid;
  grid-template-columns: 1fr auto;

  .filter-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  @include mdAndBelow {
    grid-template-columns: 1fr;

    .filter-wrapper {
      order: -1;
    }
  }

  .default-btn {
    span { margin-right: 5px; }
  }
}

::v-deep {
  tr td:first-child {
    padding: 0;
    padding-left: 10px;
  }
}
</style>
